module.exports = __webpack_public_path__ + "img/renwu_walk00.31fcf6a8.gif";